<template>
  <div class="root">
    <ul class="ul_left">
      <li v-for="(item, index) in li_bg" :key="index" @click="changeBg(index)">
        <img :src="index == idx ? item.on : item.off" alt />
      </li>
    </ul>
    <ul class="ul_right">
      <li class="li_right" v-for="(title1, index1) in titles[idx].slice((currentpage - 1) * pagesize, currentpage * pagesize)"
        :key="index1">
        <router-link :to="{ name: '意向转出受让详情', query: { id: title1.id } }">{{ title1.projectname }}</router-link>
        <p>
          <span>{{ title1.logintime }}</span>
          <!-- <span>来源：{{title1.address}}</span> -->
        </p>
      </li>
    </ul>

    <div v-if="titles[idx].length > 0">
      <el-pagination prev-text="上一页" next-text="下一页" @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :page-size="pagesize" layout="prev, pager, next, jumper" :total="titles[idx].length"></el-pagination>
    </div>
    <h3 v-else style="font-size:24px">暂无数据</h3>
  </div>
</template>

<script>
export default {
  data() {
    return {
      idx: 0,
      li_bg: [
        {
          on: require("../assets/img/意向转出1.png"),
          off: require("../assets/img/意向转出0.png"),
        },
        {
          on: require("../assets/img/意向受让1.png"),
          off: require("../assets/img/意向受让0.png"),
        },
      ],
      titles: [
        [], []
      ],
      //   每页数据条数
      pagesize: 10,
      currentpage: 1,
      inputpage: 1,
    };
  },
  created() {

    // 意向转出数据
    let url0 = "yixiangzhuanchu";
    console.log(this.ajax_url(url0).data);
    this.titles[0] = this.ajax_url(url0).data;

    // 意向受让数据
    let url1 = "yixiangshorang";
    console.log(this.ajax_url(url1).data);
    this.titles[1] = this.ajax_url(url1).data;

    // 重置idx
    this.idx = this.$route.query.id ? this.$route.query.id : 0;
  },
  mounted() { },
  computed: {},
  watch: {},
  methods: {
    changeBg(i) {
      this.$router.push({ name: "意向转出受让", query: { id: i } });
      this.idx = i;
    },
    // 当前每夜多少条
    handleSizeChange(size) {
      this.pagesize = size;
    },
    // 当前页数
    handleCurrentChange(currentpage) {
      this.currentpage = currentpage;
    },
  },
};
</script>

<style scoped>
.root {
  min-height: 1180px;
  margin: 0 auto;
  margin-bottom: 35px;
  width: 1860px;
  height: auto;
  background: #ffffff;
  box-shadow: 0px 0px 24px rgba(21, 21, 21, 0.1);
  opacity: 1;
  overflow: hidden;
}

.ul_left {
  display: block;
  width: 260px;
  height: auto;
  float: left;
  /* background-color: rebeccapurple; */
  padding: 40px 100px;
  list-style: inside none;
}

.ul_left>li {
  display: block;
  width: 260px;
  height: 92px;
  /* background-color: red; */
  margin-bottom: 10px;
  cursor: pointer;
}

.ul_right {
  display: block;
  width: 1300px;
  max-height: 1230px;
  overflow: hidden;
  list-style: inside none;
  margin-bottom: 40px;
}

.ul_right .li_right {
  display: block;
  width: 1300px;
  height: 122px;
  border-bottom: 1px dotted #bebebe;
}

.li_right>a {
  display: block;
  padding: 37px 0 19px 0;
  max-width: 1200px;
  height: 26px;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 26px;
  color: #666666;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.li_right>p {
  display: block;
  width: auto;

  height: 21px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 21px;
  color: #999999;
}

.li_right>p>span {
  display: inline-block;
  width: 250px;
}

.el-pagination {
  text-align: center;
}
</style>

